import { ErrorMessage, useFormikContext } from 'formik'
import DropdownIcon from 'icon/dropdown'
import React from 'react'

export default function Select({
  name,
  placeholder,
  label,
  options = [],
  onSelect,
  value,
  className = '',
  required,
}) {
  const formik = useFormikContext()
  const inputProps = name ? formik.getFieldProps(name) : {}

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium text-[#BA141B]"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <div className="relative w-full">
        {/* Dropdown icon */}
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <DropdownIcon className="h-5 w-5 text-[#BA141B]" />
        </div>

        <select
          id={name}
          value={value ?? ''}
          onChange={onSelect}
          {...inputProps}
          className={`
            w-full
            px-4 py-2.5
            pr-10
            text-sm
            text-gray-900
            bg-white
            border border-[#BA141B]
            rounded-lg
            shadow-sm
            outline-none
            appearance-none
            cursor-pointer
            focus:border-[#BA141B]
            focus:ring-2
            focus:ring-[#BA141B]/30
            focus:ring-offset-1
            transition-all duration-150
            disabled:opacity-60
            disabled:cursor-not-allowed
          `}
        >
          <option value="" disabled>
            {placeholder || 'Select option'}
          </option>

          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>

        {name && (
          <ErrorMessage
            name={name}
            component="div"
            className="text-xs text-red-600 font-light mt-1.5 ml-1"
          />
        )}
      </div>
    </div>
  )
}